import { Box, Typography } from '@mui/material';
import { TouristicPlace } from '../../../../types/types';
import TouristicPlaceCard from './TouristicPlaceCard';

type Props = {
    title: string;
    places: TouristicPlace[];
};

const TouristicSection: React.FC<Props> = ({ title, places }) => {
    return (
        <Box sx={{ width: '100%', maxWidth: '1200px', mx: 'auto', mb: 6 }}>
            <Typography
                variant="h4"
                gutterBottom
                sx={{ mb: 4, color: 'text.primary', textAlign: 'center' }}
            >
                {title}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 4,
                    justifyContent: 'center',
                }}
            >
                {places.map((place) => (
                    <TouristicPlaceCard key={place.title} place={place} />
                ))}
            </Box>
        </Box>
    );
};

export default TouristicSection;
